import { render, staticRenderFns } from "./OportunidadesQuadro.vue?vue&type=template&id=6536fe2a"
import script from "./OportunidadesQuadro.vue?vue&type=script&lang=js"
export * from "./OportunidadesQuadro.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports